// Google login client id.
export const googleClientId = '986227939318-qq8tobreajhd6j1135h2sloblv5fkic2'
